import { Gender } from "../Constants/Gender";
import { RvqPreferenceType } from "../Constants/RvqPreferenceType";
import { ValueSetType } from "../Constants/ValueSetType";
import { QuebecVaccinationRegistryHelper } from "../QuebecVaccinationRegistryHelper";
import { BaseRvqPreference } from "./BaseRvqPreference";
import { CodeValue } from "./CodeValue";

class RvqPractitionerPreference extends BaseRvqPreference {
    public QuebecVaccinationRegistryId: number;
    public GivenName: string;
    public FamilyName: string;
    public PermitNumber: string;
    public Gender: Gender;
    public RolesCode: CodeValue[];
    public IsActive: boolean;

    public constructor(init?: Partial<RvqPractitionerPreference>) {
        super(init);

        this.Type = RvqPreferenceType.Practitioner;
        this.DisplayName = this.getDisplayName(init.RolesCode, init.GivenName, init.FamilyName, init.PermitNumber, init.IsActive);
    }

    /**
     * A comparable identifier for the RVQ entity. For example, the practitioner ID for a practitioner preference, or the medication + lot ID for a medication preference.
     */
    public get comparableRvqId(): string {
        return this.QuebecVaccinationRegistryId.toString();
    }

    private getDisplayName(roles: CodeValue[], givenName: string, familyName: string, permitNumber: string, IsActive: boolean): string {
        const role = roles?.map(x => QuebecVaccinationRegistryHelper.translateValueSetString(x, ValueSetType.PractitionnerRole)).join(", ") ?? "";
        let str = `${givenName} ${familyName}`;
        if (permitNumber)
            str += ` - ${permitNumber}`;
        str += ` (${role})`;

        if (!IsNullOrUndefined(IsActive))
            str += " - " + cacheStore.GetString(IsActive ? "ActiveLabel" : "InactiveLabel");

        return str;
    }
}

export { RvqPractitionerPreference };
